__turbopack_context__.v({
  "callMe": "FreelanceSpecs-module__o1LJ4W__callMe",
  "callMeContainer": "FreelanceSpecs-module__o1LJ4W__callMeContainer",
  "icon": "FreelanceSpecs-module__o1LJ4W__icon",
  "iconWrapper": "FreelanceSpecs-module__o1LJ4W__iconWrapper",
  "label": "FreelanceSpecs-module__o1LJ4W__label",
  "linkLabel": "FreelanceSpecs-module__o1LJ4W__linkLabel",
  "list": "FreelanceSpecs-module__o1LJ4W__list",
  "wrapper": "FreelanceSpecs-module__o1LJ4W__wrapper",
});
